module.exports = __webpack_public_path__ + "assets/4a4a1b1525de520a876b1ee064693d64.svg";